import IcpChart from './IcpChart';
import IcpTable from './IcpTable';
import IcpGenericChart from './IcpGenericChart';

export default {
  'icp-chart': IcpChart,
  'icp-table': IcpTable,
  'icp-generic-chart': IcpGenericChart,
};
